(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Scroll Animation System
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.fade-in-section');
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // 一度アニメーションが実行されたら監視を停止
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach(element => {
      observer.observe(element);
    });
  }

  // Custom Header Navigation Menu（2点 → 1点 → 4点 ドットアニメ付き）
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.getElementById('menu-toggle');
    const navigation = document.getElementById('header-navigation');
    const MENU_DOTS_MS = 550;
    const menuTriggerButtons = [menuToggle].filter(Boolean);

    function menuReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setMenuA11yOpen(isOpen) {
      if (!menuToggle) return;
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    }

    function clearOpenAnimClasses() {
      menuTriggerButtons.forEach((btn) => {
        if (btn) btn.classList.remove('header__menu-anim--open', 'header__menu-anim--close');
      });
    }

    function setDotsOpenSettled() {
      menuTriggerButtons.forEach((btn) => {
        if (btn) {
          btn.classList.remove('header__menu-anim--open', 'header__menu-anim--close');
          btn.classList.add('header__menu--dots-open');
        }
      });
    }

    function closeNavigationInstant() {
      if (navigation) {
        navigation.classList.remove('active');
        document.body.style.overflow = '';
      }
      clearOpenAnimClasses();
      menuTriggerButtons.forEach((btn) => {
        if (btn) btn.classList.remove('header__menu--dots-open');
      });
      setMenuA11yOpen(false);
    }

    var menuAnimating = false;

    function openMenuWithDots() {
      if (!menuToggle || !navigation || menuAnimating) {
        return;
      }
      if (navigation.classList.contains('active')) {
        return;
      }
      if (menuReducedMotion()) {
        clearOpenAnimClasses();
        menuTriggerButtons.forEach((btn) => {
          if (btn) {
            btn.classList.remove('header__menu-anim--close');
            btn.classList.add('header__menu--dots-open');
          }
        });
        navigation.classList.add('active');
        document.body.style.overflow = 'hidden';
        setMenuA11yOpen(true);
        return;
      }
      menuAnimating = true;
      clearOpenAnimClasses();
      menuTriggerButtons.forEach((btn) => {
        if (btn) {
          btn.classList.remove('header__menu--dots-open');
        }
      });
      menuTriggerButtons.forEach((btn) => {
        if (btn) {
          btn.classList.add('header__menu-anim--open');
        }
      });
      navigation.classList.add('active');
      document.body.style.overflow = 'hidden';
      setMenuA11yOpen(true);
      const dotsEl = menuToggle.querySelector('.header__menu-dots');
      var openSettled = false;
      function endOpen() {
        if (openSettled) {
          return;
        }
        openSettled = true;
        menuAnimating = false;
        if (tOpen) {
          window.clearTimeout(tOpen);
          tOpen = null;
        }
        if (dotsEl) {
          dotsEl.removeEventListener('animationend', onOpenEnd);
        }
        if (navigation && navigation.classList.contains('active')) {
          setDotsOpenSettled();
        }
      }
      var tOpen = null;
      if (dotsEl) {
        var onOpenEnd = function (e) {
          if (!e || !e.target || !e.target.classList || !e.target.classList.contains('header__menu-dot')) {
            return;
          }
          if (!e.animationName || e.animationName.indexOf('hmd0-open') === -1) {
            return;
          }
          endOpen();
        };
        dotsEl.addEventListener('animationend', onOpenEnd);
        tOpen = window.setTimeout(endOpen, MENU_DOTS_MS + 30);
      } else {
        menuAnimating = false;
        if (navigation && navigation.classList.contains('active')) {
          setDotsOpenSettled();
        }
      }
    }

    function closeNavigationWithDots() {
      if (!menuToggle || !navigation || menuAnimating) {
        return;
      }
      if (!navigation.classList.contains('active')) {
        return;
      }
      if (menuReducedMotion()) {
        closeNavigationInstant();
        return;
      }
      menuAnimating = true;
      menuTriggerButtons.forEach((btn) => {
        if (btn) {
          btn.classList.remove('header__menu-anim--open');
          btn.classList.add('header__menu-anim--close');
        }
      });
      setMenuA11yOpen(true);
      const dotsEl = menuToggle.querySelector('.header__menu-dots');
      var closeSettled = false;
      function finish() {
        if (closeSettled) {
          return;
        }
        closeSettled = true;
        menuAnimating = false;
        if (tClose) {
          window.clearTimeout(tClose);
          tClose = null;
        }
        if (dotsEl) {
          dotsEl.removeEventListener('animationend', onCloseEnd);
        }
        closeNavigationInstant();
      }
      var tClose = null;
      if (dotsEl) {
        var onCloseEnd = function (e) {
          if (!e || !e.target || !e.target.classList || !e.target.classList.contains('header__menu-dot')) {
            return;
          }
          if (!e.animationName || e.animationName.indexOf('hmd0-close') === -1) {
            return;
          }
          finish();
        };
        dotsEl.addEventListener('animationend', onCloseEnd);
        tClose = window.setTimeout(finish, MENU_DOTS_MS + 30);
      } else {
        finish();
      }
    }

    // メニュー開閉
    if (menuToggle && navigation) {
      menuToggle.addEventListener('click', function () {
        if (menuAnimating) {
          return;
        }
        if (navigation.classList.contains('active')) {
          closeNavigationWithDots();
        } else {
          openMenuWithDots();
        }
      });
    }

    if (navigation) {
      navigation.addEventListener('click', function (e) {
        if (e.target === navigation) {
          closeNavigationWithDots();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navigation && navigation.classList.contains('active')) {
        if (!menuAnimating) {
          closeNavigationWithDots();
        }
      }
    });

    // Initialize scroll animations
    initScrollAnimations();
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
